import { create } from 'zustand';

import {
  Integration,
  IntegrationServices,
  IntegrationState as TIntegrationState,
} from '../../../common/types/integrations';
import { integrationsData } from '../helpers/data';

interface IntegrationState {
  integrations: Integration[];
  setIntegrations: (integrations: Integration[]) => void;
  setIntegrationState: (service: IntegrationServices, state: TIntegrationState) => void;
}

export const useIntegrationStore = create<IntegrationState>((set, get) => ({
  integrations: integrationsData,
  setIntegrations: () => set(state => ({ integrations: state.integrations })),
  setIntegrationState: (service, state) => {
    const integrations = get().integrations;
    const index = integrations.findIndex(item => item.service === service);

    integrations[index].state = state;
    set({ integrations });
  },
}));
